// extracted by mini-css-extract-plugin
export default {"transactionHistory":"transactions_transactionHistory__H-nnx"};